import type { MetaContent } from "./meta-content";

/**
 * @deprecated All images in meta.images on a should be
 * possible to use as so called poster images,
 * so this function is not needed
 * it's only here for backwards compatibility, selects
 * first image in image array and returns it.
 */
const parseMetaContentPosterImage = (meta: MetaContent | undefined) => {
    if (typeof meta === "undefined") return undefined;
    return meta.images?.[0];
    // return meta.images?.find(image => {
    //     if (isStorageItemImageReference(image)) {
    //         return !!image.tags.poster;
    //     }
    //     return image.meta.tags?.categories.includes("poster");
    // });
};

export { parseMetaContentPosterImage };
